export const changelogHistory = [
  {
    version: "2.0.0",
    date: "September 2026",
    sections: [
      {
        title: "dYs? Major Additions",
        items: [
          { bold: "AI Hand Analysis:", text: " Powered by a LightGBM model trained on thousands of simulated games! View your Expected Win % immediately after every round." },
          { bold: "Smarter Grandmaster Bots:", text: " Bots now fully understand and exploit the Royal Pair modifier, aggressively bidding and revealing trump perfectly." }
        ]
      },
      {
        title: "dY?> Bug Fixes",
        items: [
          { bold: "Infinite Spinner Fixed:", text: " Patched a critical clock desynchronization bug that caused the Trump Reveal animation to spin infinitely for some players." }
        ]
      }
    ]
  },
  {
    version: "1.3.0",
    date: "September 2026",
    sections: [
      {
        title: "✨ New Features",
        items: [
          { bold: "Randomize Teams:", text: " Hosts can now instantly shuffle seating and randomize teams in the lobby for modes 28 and 56." },
          { bold: "Unranked Matches:", text: " Added a 'Track Score' toggle in the lobby. Hosts can disable score tracking for casual games, keeping them off the global leaderboard." }
        ]
      }
    ]
  },
  {
    version: "1.2.0",
    date: "September 2026",
    sections: [
      {
        title: "✨ New Features",
        items: [
          { bold: "Active Turn Timer (28/56):", text: " Replaced the invisible 40-second AFK timeout with a strict 30-second synced timer. Auto-play now gracefully forces an automatic 'Pass' if a player goes AFK during Doubling or Redoubling phases." },
          { bold: "Host Pause Mechanics:", text: " The room Host now has access to a Pause / Resume button. Pausing freezes the backend timer, and resuming safely grants the active player a fresh 30-second window." },
          { bold: "Advanced Global Leaderboard:", text: " Added 'Recent Form (L5)' to dynamically track a player's last 5 matches with visual W/L streak badges, and 'Average Points Per Hand' over the last 5 games." }
        ]
      },
      {
        title: "🎨 UI & Architecture Polish",
        items: [
          { bold: "Dynamic Timer Chip:", text: " The active timer is now rendered as a premium physical 'Pill Chip' matching the Dealer tokens. The chip transitions to glowing red when time drops below 5 seconds." },
          { bold: "De-cluttered Nameplates:", text: " Removed the redundant 'Bid' token from the player nameplate to drastically reduce visual clutter, and adjusted the top-right token positioning." },
          { bold: "Zero-Downtime Migrations:", text: " Upgraded the matches table to log total_rounds dynamically using safe ALTER TABLE schemas that protect historical match data." },
          { bold: "Lightning-Fast API:", text: " Shifted all advanced leaderboard aggregation (e.g., fetching exactly 5 matches and executing string aggregation) entirely to the database layer via PostgreSQL Window Functions." }
        ]
      }
    ]
  },
  {
    version: "1.1.1",
    date: "August 2026",
    sections: [
      {
        title: "✨ UX & UI Improvements",
        items: [
          { bold: "High-Stakes Bid Confirmation:", text: " Added a safety confirmation overlay when attempting to place high stakes bids (20+ in Game 28, 40+ in Game 56) to prevent accidental misclicks." }
        ]
      },
      {
        title: "🐛 Bug Fixes",
        items: [
          { text: "Fixed a CSS clipping issue in the Waiting Room that prevented the Bot Difficulty dropdown from rendering properly over player cards." }
        ]
      }
    ]
  },
  {
    version: "1.1.0",
    date: "August 2026",
    sections: [
      {
        title: "🚀 Major Additions",
        items: [
          { bold: "Escalation Protocol Mode:", text: " A brand new high-stakes timer mechanic! Match stakes automatically multiply by 2x after 30 minutes, and by a massive 4x after 60 minutes." },
          { bold: "Expanded Sprint Series:", text: " Extended the Sprint Series limits! You can now configure matches to run up to 50 rounds for a true endurance challenge." },
          { bold: "Match Summary Box:", text: " Added a sleek, dynamic panel to the Waiting Room that explicitly outlines the active game rules, win conditions, and modifiers for all players." }
        ]
      },
      {
        title: "✨ UX & UI Improvements",
        items: [
          { bold: "Cinematic Round Announcements:", text: " Replaced the old intrusive splash screens with a sleek, non-disruptive pill banner for round transitions." },
          { bold: "Escalation Timer HUD:", text: " Built a dynamic HUD widget that pulses and shifts color (Gold to Yellow to Red) as the match escalates." },
          { bold: "Score Breakdown Badges:", text: " The post-round results screen now explicitly tags scores with \"ESCALATION\" badges so players understand massive point spikes." },
          { bold: "Waiting Room Dropdowns:", text: " Grouped \"Win Conditions\" seamlessly into a single dropdown, fixing state collision bugs and improving host workflow." }
        ]
      },
      {
        title: "🐛 Bug Fixes",
        items: [
          { text: "Fixed round counter logic in the Sprint Series HUD (now counts 1-N instead of 0-N)." },
          { text: "Fixed a timing issue where Round 2 was displayed prematurely during Round 1's final trick." },
          { text: "Corrected JavaScript state batching in the Waiting Room to prevent Double/Redouble from artificially showing as enabled." },
          { text: "Patched the backend JSON unmarshaler to correctly accept and broadcast complex nested match settings." }
        ]
      }
    ]
  },
  {
    version: "1.0.0",
    date: "May 2026",
    sections: [
      {
        title: "🎉 Initial Release",
        items: [
          { text: "Welcome to The Game Vault! Initial release of Game 28, 56, Poker, and Donkey." },
          { text: "Real-time multiplayer powered by Go WebSockets." },
          { text: "Fully integrated bot support." }
        ]
      }
    ]
  }
];
